<template>
  <div class="everyday-answer">
    <a-skeleton avatar active :paragraph="{ rows: 3 }" :loading="loadState" />
    <template v-if="todayHotComment.length > 0 && loadState === false">
      <div
        class="answer-item"
        v-for="(item, index) in todayHotComment"
        :key="index"
        :class="{ 'last-answer-item': index == todayHotComment.length - 1 }"
      >
        <div class="left-avatar">
          <div class="user-photo">
            <img
              :src="
                item.user_info.avatar ? item.user_info.avatar : defaultPhoto
              "
              @error="item.user_info.avatar = defaultPhoto"
            />
          </div>
          <span class="topping-tag" v-if="item.is_top == 1">{{
            $t("yearCourse.pinToTop")
          }}</span>
        </div>
        <div class="right-content" @click="lookReply(item)">
          <p class="answer-author">
            <span>{{ item.user_info.username }}</span>
            <span>{{ item.updated_at }}</span>
          </p>
          <p class="for-course" @click="lookDetail(item)">
            #{{ item.trainplan_info.name }}#
          </p>
          <p class="answer-detail">{{ item.txt }}</p>
          <template
            v-if="item.comments_type == '1' && item.img_list.length > 0"
          >
            <div
              :class="item.img_list.length > 1 ? 'img-flex-list' : 'alone-img'"
            >
              <img
                :src="li.list_page"
                v-for="(li, index) in item.img_list"
                :key="index"
                @error="li.list_page = defaultImg"
              />
            </div>
          </template>
          <div class="discuss-video" v-else-if="item.comments_type == '3'">
            <img
              src="@/assets/img/column_video/pic.png"
              class="default-cover"
              v-if="item.transcode_status != '0'"
            />
            <img
              src="@/assets/img/new/video.png"
              class="player-btn"
              @click="lookReply(item)"
            />
          </div>
          <div class="share-file" v-else-if="item.comments_type == '4'">
            <img
              src="@/assets/img/experience/doc.png"
              v-if="
                item.doc_url.file_extension === 'doc' ||
                item.doc_url.file_extension === 'docx'
              "
            />
            <img
              src="@/assets/img/experience/exl.png"
              v-else-if="
                item.doc_url.file_extension === 'xls' ||
                item.doc_url.file_extension === 'xlsx'
              "
            />
            <img src="@/assets/img/experience/pdf.png" v-else />
            <p class="file-name">{{ item.doc_url.name }}</p>
          </div>
          <!-- 转码中 -->
          <div
            class="video-transcoding"
            v-if="item.comments_type == '3' && item.transcode_status == '0'"
          >
            <p>
              <span
                class="delete-btn"
                @click.stop="deleteComment(index)"
                v-if="getDeleteState(item.user_id)"
                >{{ $t("yearCourse.delete") }}</span
              >
            </p>
            <span class="transcoding-hint"
              ><a-icon type="loading" class="loading-icon" />{{
                $t("yearCourse.postingInProgress")
              }}</span
            >
          </div>
          <!-- 点赞评论 -->
          <p class="answer-actions" v-else>
            <span class="reply-number" @click="lookReply(item)">{{
              item.reply_num
            }}</span>
            <span
              :class="item.is_praise ? 'anticon-like' : 'anticon-unlike'"
              @click.stop="praiseComment(item)"
              >{{ item.praise_num }}</span
            >
            <span
              :class="
                item.is_favorite ? 'anticon-collect' : 'anticon-uncollect'
              "
              @click.stop="collectComment(item)"
              >{{ item.fav_num }}</span
            >
          </p>
        </div>
      </div>
    </template>
    <div
      v-else-if="todayHotComment.length === 0 && loadState === false"
      class="null-answer"
    >
      <img src="@/assets/img/new/no-date.png" />
      <p>{{ $t("knowledgePage.noData") }}</p>
    </div>
    <p
      class="look-all"
      @click="lookAllComment"
      v-if="todayHotComment.length > 0 || loadState"
    >
      {{ $t("columnVideo.seeMore") }}
    </p>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      // 加载状态
      loadState: true,
      // 默认头像
      defaultPhoto: require("@/assets/img/learning_camp/basic_fc.png"),
      // 默认图片
      defaultImg: require("@/assets/img/survey/img_error.jpg"),
      // 热门评论
      todayHotComment: [],
    };
  },
  created() {
    this.getHotComment();
  },
  activated() {
    this.loadState = true;
    this.getHotComment();
  },
  methods: {
    // 设置帖子列表滚动高度
    ...mapMutations("yearCourse", ["setPostListScrollTop"]),
    getHotComment() {
      this.$axios
        .post(`index.php/mobile/learn-map/comment-list`, {
          page: 1,
          size: 10,
          list_type: "new",
        })
        .then((res) => {
          this.loadState = false;
          if (res.data.code === 0) {
            this.todayHotComment = res.data.result.list.slice(0, 2);
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
    // 查看回复
    lookReply(item) {
      // 如果视频转码未完成
      if (item.comments_type == "3" && item.transcode_status == "0") {
        return this.$toast("视频正在转码中");
      }
      sessionStorage.TOPComment = JSON.stringify(item);
      this.$router.push({
        path: "/main/postReply",
        query: {
          tid: item.trainplan_id,
          rid: item.id,
          cid: item.content_id,
        },
      });
    },
    // 查看全部
    lookAllComment() {
      this.setPostListScrollTop({
        break: true,
        top: 0,
      });
      this.$router.push({ path: "/main/365allPost", query: { type: "hot" } });
    },
    // 查看详情
    lookDetail() {
      return;
      // this.$router.push({path: '/main/365course', query: {
      //     cid: item.content_id,
      //     tid: item.trainplan_id,
      //     rid: item.resources_id,
      // }})
    },
    // 是否本人
    getDeleteState(id) {
      if (id == localStorage._user_data_id) {
        return true;
      } else {
        return false;
      }
    },
    // 点赞讨论
    praiseComment(item) {
      this.$axios
        .post(`index.php/mobile/praise/item`, {
          item: item.id,
          type: "16",
          trainplan_id: item.trainplan_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            item.praise_num = res.data.result.is_praise
              ? Number(item.praise_num) + 1
              : Number(item.praise_num) - 1;
            if (item.praise_num < 0) item.praise_num = 0;
            item.is_praise = res.data.result.is_praise;
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
    // 收藏讨论
    collectComment(item) {
      this.$axios
        .post(`index.php/mobile/favorite/item`, {
          item: item.id,
          type: "16",
          trainplan_id: item.trainplan_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            item.fav_num = res.data.result.is_favorite
              ? Number(item.fav_num) + 1
              : Number(item.fav_num) - 1;
            if (item.fav_num < 0) item.fav_num = 0;
            item.is_favorite = res.data.result.is_favorite;
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";

.everyday-answer {
  /deep/ .ant-skeleton-with-avatar {
    width: 87%;
    margin: 0.4rem auto;
  }
  .look-all {
    background: white;
    color: @mColor;
    text-align: center;
    font-size: 0.22rem;
    line-height: 0.66rem;
    border-top: 0.02rem solid #ddd;
  }
}
.answer-item {
  display: flex;
  padding: 0.3rem 0.3rem 0.24rem;
  border-bottom: #eee 0.02rem solid;
  .left-avatar {
    margin-right: 0.3rem;
    text-align: center;
    font-size: 0.2rem;
    .topping-tag {
      color: white;
      background: url("~@/assets/img/reading/topping.png") no-repeat 0.1rem
        center @unPassColor;
      background-size: 0.13rem;
      line-height: 0.3rem;
      display: inline-block;
      margin-top: 0.1rem;
      padding-left: 0.3rem;
      padding-right: 0.1rem;
    }
  }
  .user-photo {
    width: 0.76rem;
    height: 0.76rem;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right-content {
    flex: 1;
    overflow: hidden;
    .answer-author {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        font-size: 0.26rem;
        font-weight: 700;
        max-width: 4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span:nth-child(2) {
        font-size: 0.22rem;
        color: #7f8485;
      }
    }
    .for-course {
      color: @mColor;
      font-size: 0.24rem;
      margin: 0.1rem 0 0.2rem;
    }
    .answer-detail {
      font-size: 0.26rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /*autoprefixer: on */
    }
    .img-flex-list {
      display: flex;
      margin-top: 0.25rem;
      img {
        width: 31%;
        width: 1.7rem;
        height: 1.7rem;
        margin-left: 1.8%;
      }
    }
    .alone-img {
      width: 3.4rem;
      height: 3.4rem;
      margin-top: 0.25rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .discuss-video {
      height: 3.5rem;
      margin: 0.25rem 0;
      background: #e3e3e3;
      position: relative;
      .player-btn {
        .absolutely-centered;
        width: 0.8rem;
      }
      .default-cover {
        width: 100%;
        height: 100%;
      }
    }
    .share-file {
      display: flex;
      padding: 0.2rem;
      border: 0.02rem solid #eee;
      border-radius: 0.08rem;
      align-items: center;
      font-size: 0.26rem;
      margin-top: 0.25rem;
      img {
        width: 0.3rem;
      }
      .file-name {
        flex: 1;
        margin-left: 0.15rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: @mColor;
      }
    }
    .video-transcoding {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .delete-btn {
        color: #a9aeaf;
        text-decoration: underline;
        font-size: 0.24rem;
      }
      .transcoding-hint {
        font-size: 0.26rem;
        color: @mColor;
        .loading-icon {
          margin-right: 0.05rem;
        }
      }
    }
  }
  .answer-actions {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    font-size: 0.26rem;
    margin-top: 0.2rem;
    .reply-number {
      display: inline-block;
      background: url("~@/assets/img/learning_camp/comment.png") no-repeat left
        top;
      background-size: 0.35rem;
      padding-left: 0.4rem;
      margin-left: 0.3rem;
    }
    .anticon-like {
      background: url("~@/assets/img/learning_camp/like_cur.png") no-repeat left
        top;
      background-size: 0.35rem;
      padding-left: 0.4rem;
      margin-left: 0.3rem;
    }
    .anticon-unlike {
      .anticon-like;
      background: url("~@/assets/img/learning_camp/praise.png") no-repeat left
        top;
      background-size: 0.35rem;
    }
    .anticon-collect {
      background: url("~@/assets/img/learning_camp/faved.png") no-repeat left
        top;
      background-size: 0.35rem;
      padding-left: 0.4rem;
    }
    .anticon-uncollect {
      .anticon-collect;
      background: url("~@/assets/img/learning_camp/fav2.png") no-repeat left top;
      background-size: 0.35rem;
    }
  }
}
.last-answer-item {
  border-bottom: none;
}
.null-answer {
  text-align: center;
  padding: 0.5rem 0;
  color: #888;
  font-size: 0.26rem;
  img {
    width: 1.8rem;
    margin: 0 auto 0.3rem;
  }
}
</style>
